import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import { AdminMainText } from "../../sections/AdminDashboard/shared/adminUx";
import {
  AdminMetric,
  AdminSupportingText,
  AdminFormSecondaryAction,
} from "../../sections/AdminDashboard/shared/adminUx";
import { AdminWidgetHeader, AdminWidgetPeriodFilter } from "../BusinessDashboard/AdminWidgetChrome";
import * as echarts from "echarts";

const SavedPostsWidget = () => {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const [filterPeriod, setFilterPeriod] = useState("Last 7 Days");

  const savedPostsDataByPeriod = {
    "Last 7 Days": {
      total: 12,
      categories: [
        { name: "Plumbing", count: 5, percentage: 42, color: "#2E00FF" },
        { name: "Electrical", count: 4, percentage: 33, color: "#03A62C" },
        { name: "Cleaning", count: 3, percentage: 25, color: "#7B62D9" },
      ],
      posts: [
        {
          id: 1,
          title: "Expert General Plumbing Solutions for Every Home",
          thumbnail:
            "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&h=100&fit=crop",
        },
        {
          id: 2,
          title: "Expert General Plumbing Solutions for Every Home",
          thumbnail:
            "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=100&h=100&fit=crop",
        },
      ],
    },
    "Last 14 Days": {
      total: 18,
      categories: [
        { name: "Plumbing", count: 7, percentage: 39, color: "#2E00FF" },
        { name: "Electrical", count: 6, percentage: 33, color: "#03A62C" },
        { name: "Cleaning", count: 5, percentage: 28, color: "#7B62D9" },
      ],
      posts: [
        {
          id: 1,
          title: "Expert General Plumbing Solutions for Every Home",
          thumbnail:
            "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&h=100&fit=crop",
        },
        {
          id: 3,
          title: "Professional Electrical Installation Services",
          thumbnail:
            "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=100&h=100&fit=crop",
        },
      ],
    },
    "Last 30 Days": {
      total: 28,
      categories: [
        { name: "Plumbing", count: 10, percentage: 36, color: "#2E00FF" },
        { name: "Electrical", count: 9, percentage: 32, color: "#03A62C" },
        { name: "Cleaning", count: 9, percentage: 32, color: "#7B62D9" },
      ],
      posts: [
        {
          id: 1,
          title: "Expert General Plumbing Solutions for Every Home",
          thumbnail:
            "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&h=100&fit=crop",
        },
        {
          id: 4,
          title: "Complete Home Renovation Services",
          thumbnail:
            "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=100&h=100&fit=crop",
        },
      ],
    },
    "Last 90 Days": {
      total: 45,
      categories: [
        { name: "Plumbing", count: 16, percentage: 36, color: "#2E00FF" },
        { name: "Electrical", count: 15, percentage: 33, color: "#03A62C" },
        { name: "Cleaning", count: 14, percentage: 31, color: "#7B62D9" },
      ],
      posts: [
        {
          id: 1,
          title: "Expert General Plumbing Solutions for Every Home",
          thumbnail:
            "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&h=100&fit=crop",
        },
        {
          id: 5,
          title: "Landscaping and Garden Design Services",
          thumbnail:
            "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=100&h=100&fit=crop",
        },
      ],
    },
  };

  const savedPostsData = savedPostsDataByPeriod[filterPeriod];
  const samplePosts = savedPostsData.posts;

  useEffect(() => {
    if (!chartRef.current) return;
    const chart = echarts.init(chartRef.current);
    const option = {
      tooltip: false,
      series: [
        {
          name: "Saved Posts",
          type: "pie",
          radius: "90%",
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 0,
            borderColor: "#fff",
            borderWidth: 0,
          },
          label: { show: false, position: "center" },
          labelLine: { show: false },
          data: savedPostsData.categories.map((category) => ({
            value: category.count,
            name: category.name,
            itemStyle: { color: category.color },
          })),
        },
      ],
    };
    chart.setOption(option);
    return () => chart.dispose();
  }, [filterPeriod, savedPostsData]);

  const handleViewAll = () => {
    navigate("/customer-dashboard/saved-posts");
  };

  const handlePostClick = () => {
    navigate("/service-detail/?id=53");
  };

  return (
    <DashboardMainContainer className="masonry-item w-[350px] h-[550px] flex flex-col overflow-hidden">
      <AdminWidgetHeader title="Saved Posts">
        <AdminWidgetPeriodFilter
          period={filterPeriod}
          onPeriodChange={setFilterPeriod}
          periods={["Last 7 Days", "Last 14 Days", "Last 30 Days", "Last 90 Days"]}
        />
      </AdminWidgetHeader>

      <div className="flex-1 p-4 space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <AdminMetric size="large" className="text-offblack mb-1 block">
              {savedPostsData.total}
            </AdminMetric>
            <AdminSupportingText className="text-offblack block">Saved Posts</AdminSupportingText>
          </div>
          <div ref={chartRef} className="w-28 h-28 flex-shrink-0" />
        </div>

        <div className="flex flex-wrap justify-between gap-2 px-[10px]">
          {savedPostsData.categories.map((category) => (
            <div key={category.name} className="flex items-start gap-2">
              <div
                className="w-3 h-3 rounded-sm mt-1"
                style={{ backgroundColor: category.color }}
              />
              <div>
                <AdminSupportingText className="text-offblack block">
                  {category.name}
                </AdminSupportingText>
                <AdminMetric size="small" className="text-offblack block">
                  {category.percentage}%
                </AdminMetric>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-2">
          {samplePosts.map((post) => (
            <div
              key={post.id}
              onClick={handlePostClick}
              className="group flex items-center gap-3 py-2 rounded-lg cursor-pointer transition-colors hover:bg-mistygray"
            >
              <div className="w-20 h-20 bg-lightgray rounded-lg flex-shrink-0 overflow-hidden">
                <img
                  src={post.thumbnail}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <AdminMainText className="font-medium truncate block group-hover:text-primaryblue transition-colors">
                  {post.title}
                </AdminMainText>
              </div>
            </div>
          ))}
        </div>

        <div className="pt-0">
          <AdminFormSecondaryAction type="button" onClick={handleViewAll} className="!w-full">
            View all saved
          </AdminFormSecondaryAction>
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default SavedPostsWidget;
